import React from 'react';

const PrivacyPolicy = () => {
    return (
        <main className="main-container">
            <div className="main-wrapper">
                <section className="review-area pb-100 pt-40" id="privacy-policy">
                    <div className="container">
                        <div className="row justify-content-start align-items-center">
                            <div className="col-lg-6 video-left">
                                <br />
                                <header className="pt-120">
                                    <h1 className="page-heading">Privacy Policy</h1>
                                    <p><strong>Effective Date:</strong> June 30, 2025</p>
                                </header>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="video-sec-area pb-100 pt-40" id="about">
                    <div className="container">
                        <div className="row justify-content-start align-items-center">
                            <article className="col-lg-6 video-left">
                                <p>
                                    At <strong>Baptist Church Alkapoor</strong>, we are committed to protecting your privacy.
                                    This Privacy Policy explains how we collect, use, and protect your information when you use our website.
                                </p>
                                <ol>
                                    <li>
                                        <p className="contact-bold">1. Information We Collect</p>
                                        <ul>
                                            <li>
                                                <p className="contact-bold">a) Google Maps</p>
                                                We use a static image preview of Google Maps to show our church location without loading any third-party services.
                                                Only if you accept cookies will the interactive Google Map embed load.

                                                If consent is given, Google may collect:
                                                <ul>
                                                    <li>Your IP address</li>
                                                    <li>Location data based on browser/device</li>
                                                    <li>Browser type and settings</li>
                                                    <li>Cookies for user preferences</li>
                                                </ul>
                                                Learn more:
                                                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                                                    https://policies.google.com/privacy
                                                </a>
                                            </li>
                                            <li className="mt-3">
                                                <p className="contact-bold">b) Push Notifications (OneSignal)</p>
                                                We use OneSignal to deliver optional browser-based notifications. If you opt in, OneSignal may collect:
                                                <ul>
                                                    <li>Device ID</li>
                                                    <li>Browser type, version, and language</li>
                                                    <li>IP address and general location</li>
                                                    <li>Interaction with notifications</li>
                                                    <li>Cookies or local storage data</li>
                                                </ul>
                                                More info:
                                                <br />
                                                <a href="https://onesignal.com/privacy_policy" target="_blank" rel="noopener noreferrer">
                                                    https://onesignal.com/privacy_policy
                                                </a>
                                            </li>
                                        </ul>
                                    </li>

                                    <li className="mt-3">
                                        <p className="contact-bold">2. Legal Basis for Data Processing</p>
                                        <ul>
                                            <li>We rely on your consent, given through our cookie banner, to process any data via third-party services.</li>
                                            <li>You may withdraw consent at any time through browser settings or by declining cookies.</li>
                                        </ul>
                                    </li>

                                    <li className="mt-3">
                                        <p className="contact-bold">3. Cookies and Tracking</p>
                                        <ul>
                                            <li>We only use cookies required for:
                                                <ul>
                                                    <li>Displaying Google Maps</li>
                                                    <li>Managing push notifications</li>
                                                </ul>
                                            </li>
                                            <li>We do not use cookies for:
                                                <ul>
                                                    <li>Advertising</li>
                                                    <li>Analytics</li>
                                                    <li>Cross-site tracking</li>
                                                </ul>
                                            </li>
                                            <li>You may accept or reject cookies via our banner.</li>
                                        </ul>
                                    </li>

                                    <li className="mt-3">
                                        <p className="contact-bold">4. Your Rights</p>
                                        <ul>
                                            <li>You may have the right to:
                                                <ul>
                                                    <li>Access personal data held by third parties</li>
                                                    <li>Withdraw consent for processing</li>
                                                    <li>Request deletion of personal data</li>
                                                    <li>Restrict or object to data processing</li>
                                                    <li>File a complaint with a regulatory authority</li>
                                                </ul>
                                            </li>
                                            <li>To exercise any rights, please contact us using the information below.</li>
                                        </ul>
                                    </li>

                                    <li className="mt-3">
                                        <p className="contact-bold">5. Children’s Privacy</p>
                                        <ul>
                                            <li>This website is not intended for children under 13. We do not knowingly collect personal data from children.</li>
                                            <li>If you believe data may have been collected from a child, please contact us immediately.</li>
                                        </ul>
                                    </li>

                                    <li className="mt-3">
                                        <p className="contact-bold">6. Data Sharing</p>
                                        <ul>
                                            <li>We do not sell or share your personal data.</li>
                                            <li>Third-party services such as Google and OneSignal may process your data under their own privacy policies.</li>
                                        </ul>
                                    </li>

                                    <li className="mt-3">
                                        <p className="contact-bold">7. Changes to This Policy</p>
                                        <ul>
                                            <li>We may update this policy periodically. All changes will be posted on this page with a revised effective date.</li>
                                        </ul>
                                    </li>

                                    <li className="mt-3">
                                        <p className="contact-bold">8. Contact Us</p>
                                        <ul>
                                            <li>For questions or concerns, please contact us:</li>
                                            <li>
                                                <strong>Baptist Church Alkapoor</strong><br /><br />
                                                <span className="contact-bold">
                                                    Email: &nbsp;
                                                </span>
                                                <a href="mailto:baptistchurchalkapur@gmail.com">baptistchurchalkapur@gmail.com</a><br /><br />
                                                <p className="contact-bold">
                                                    Address:
                                                </p>
                                                1st Floor,
                                                Star Celestia Banquet Hall,
                                                <br />
                                                Ideal Park,
                                                Opp. Netaji Park,
                                                <br />
                                                Road no 16,
                                                Alkapoor Township,
                                                <br />
                                                Hyderabad
                                                <br />
                                                <br />
                                            </li>
                                        </ul>
                                    </li>

                                    <li className="mt-3">
                                        <p className="contact-bold">9. Data Controller</p>
                                        <ul>
                                            <li>The data controller responsible for this website is:</li>
                                            <li><strong>Baptist Church Alkapoor</strong>, Alkapoor Township, Hyderabad, India</li>
                                        </ul>
                                    </li>
                                </ol>
                            </article>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    );
};

export default PrivacyPolicy;
